<template>
  <div class="loader" v-show="visible">
    <div class="first">
      <div class="second">
        <div class="third">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loader",
  props:{
    visible: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../scss/variables.scss';

  .loader {
    display: block;
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.6);
    z-index: 999999;

    div {
      border: 5px solid transparent;
      border-top: 5px solid $secondary-base;
      border-radius: 200px;
      -webkit-animation: spin 2s infinite linear;
    }
    .first {
       width: 100px;
       height: 100px;
       position: absolute;
       top: 50%;
       left: 50%;
       margin-left: -50px;
       margin-top: -50px;
    }
    .second {
       width: 80px;
       height: 80px;
       margin: 10px;
    }
    .third {
       width: 60px;
       height: 60px;
       margin: 10px;
    }
    @-webkit-keyframes spin {
      0% {-webkit-transform: rotateZ(0deg);}
      100% {-webkit-transform: rotateZ(360deg);}
    }
  }
</style>
